import { createAction } from "@reduxjs/toolkit";
export var AuthActionType;
(function (AuthActionType) {
    AuthActionType["LOGIN"] = "AUTH/LOGIN";
    AuthActionType["LOGIN_SUCCESSFUL"] = "AUTH/LOGIN_SUCCESSFUL";
    AuthActionType["LOGIN_FAILURE"] = "AUTH/LOGIN_FAILURE";
    AuthActionType["LOGOUT"] = "AUTH/LOGOUT";
})(AuthActionType || (AuthActionType = {}));
export const login = createAction(AuthActionType.LOGIN);
export const loginSuccessful = createAction(AuthActionType.LOGIN_SUCCESSFUL);
export const loginFailure = createAction(AuthActionType.LOGIN_FAILURE);
export const logout = createAction(AuthActionType.LOGOUT);
